**Return** is the overall return of the index over the selected time period.
